import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {
  ProductDetailsMode
} from "../../../model/enums/ProductDetails.enum";
import {ProductAdded} from "../../../model/enums/ProductAdd";
import {ProductDetailsService} from "../../../services/product-details.service";
import {AddInsurance} from "../../../model/enums/InsuranceAdd";
import {TranslationService} from "../../../services/translation.service";

@Component({
  selector: 'v-product-success',
  templateUrl: './product-success.component.html',
  styleUrls: ['./product-success.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductSuccessComponent {
  @Input() product: ProductAdded;

  @Input() priceInformations;
  @Input() insurance;
  @Input() picture;
  @Output() switchMode: EventEmitter<string> = new EventEmitter<string>();
  @Output() notification: EventEmitter<string> = new EventEmitter<string>();
  @Output() incraseCart: EventEmitter<void> = new EventEmitter<void>();
  submitted = false;

  constructor(private productDetailsService : ProductDetailsService, private translate: TranslationService) {
  }

  backToDetails() {
    this.switchMode.emit(ProductDetailsMode.details)
  }

  goToCart() {
    window.location.href = '/cart';
  }


  confirmInsurance() {
    this.submitted = true;
    this.productDetailsService.addInsurance(this.product.code).subscribe(
      (response: AddInsurance) => {
        const {code, product} = response;

        if(code === 'success') {
          window['ACC']?.product.addInsuranceDataLayer(product);
          this.incraseCart.emit();
          this.goToCart();
        } else {
          this.notification.emit(response.message || response.code);
        }
        this.submitted = false;
      },
      error => {
        this.translate.getWordByKey('productDetails.cart.error').subscribe(message => {
          this.notification.emit(message);
          this.submitted = false;
        });
      }
    );
  }
}
